import SpriteSymbol from "../../../node_modules/svg-baker-runtime/browser-symbol.js";
import sprite from "../../../node_modules/svg-sprite-loader/runtime/browser-sprite.build.js";
var symbol = new SpriteSymbol({
  "id": "icon-zoom",
  "use": "icon-zoom-usage",
  "viewBox": "0 0 24 24",
  "content": "<symbol fill=\"none\" xmlns=\"http://www.w3.org/2000/svg\" viewBox=\"0 0 24 24\" id=\"icon-zoom\"><path d=\"m20.412 9.758-1.337.022-.201-4.254-6.046 6.046-.955-.955 6.046-6.045-4.253-.202.021-1.336 6.396.329.329 6.395Z\" fill=\"#000\" /><path d=\"m3.034 13.699 1.336-.021.202 4.253 6.045-6.046.955.955-6.046 6.045 4.254.202-.022 1.336-6.395-.328-.33-6.396Z\" fill=\"currentColor\" /></symbol>"
});
var result = sprite.add(symbol);
export default symbol